export default __webpack_public_path__ + "static/media/LEVEL8.b3433b70.png";